import { twMerge } from 'tailwind-merge'

type Props = {
  label?: string
  show?: boolean
  size?: string
} & React.ComponentPropsWithoutRef<'div'>

export function SuspenseLoading({ label }: Props) {
  return <span className='sr-only'>{label}</span>
  // return <PageLoading show={true} className='top-32' label={label || 'Loading...'} />
}

export function Loading({ show, label, size, className, ...rest }: Props) {
  return (
    <div
      aria-hidden={!show}
      className={twMerge('z-10 text-center transition duration-300', className, show ? 'block' : 'hidden')}
      {...rest}
    >
      <svg
        className={twMerge('mx-auto animate-spin text-zinc-800 dark:text-zinc-300', size || 'size-20')}
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
      >
        <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
        <path
          fill='currentColor'
          d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
        />
      </svg>
      {label ? (
        <p className='m-0 mt-4 text-base font-medium text-zinc-800 dark:text-zinc-300'>{label}</p>
      ) : (
        <span className='sr-only'>Loading</span>
      )}
    </div>
  )
}

type PageLoadingProps = {
  className?: string
  show: boolean
  label?: string
} & React.ComponentPropsWithoutRef<'div'>

export function PageLoading({ className, show, label, ...rest }: PageLoadingProps) {
  return (
    <div
      aria-hidden={!show}
      className={twMerge('absolute top-12 right-0 left-0 z-10 mx-auto w-fit flex flex-col gap-4', className, !show && 'hidden')}
      {...rest}
    >
      <div className='m-auto rounded-full bg-white p-2 shadow-lg dark:bg-zinc-200 w-fit'>
        <span className='sr-only'>Loading page</span>
        <svg
          className='size-10 animate-spin text-red-800'
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
          aria-hidden='true'
        >
          <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
          <path
            fill='currentColor'
            d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
          />
        </svg>
      </div>
      {label && <div className='font-medium text-sm tracking-wide'>{label}</div>}
    </div>
  )
}
